import React, { useState } from "react";
import { useTranslation } from "/utils/hooks/useCustomTranslation";

import Flow from "./components/Withdraw-Flow";
import Confirm from "./components/Withdraw-Confirm";
import { payToLocaleString } from "/utils/utils";
import CustomButton from "/components/core/ButtonDefault";
import userInfoImg from "/assets/img/profile/user_info.png";

const parts = {
  confirm: Confirm,
  flow: Flow,
};

function navigate(to, { replace = false } = {}) {
  if (replace) {
    window.history.replaceState({}, "", to);
  } else {
    window.history.pushState({}, "", to);
  }
}

export default function Withdraw(props) {
  const { t } = useTranslation();
  const { onClose, state, auth } = props;
  const [activePart, setActivePart] = useState({
    path: "flow",
    queryParams: {},
  });
  const Component = parts[activePart.path];

  // Block withdrawal if no email
  if (!auth?.email) {
    const handleGoToProfile = () => {
      if (onClose) onClose();
      setTimeout(() => navigate("/profile/settings"), 0);
    };
    return (
      <div
        className="withdraw-no-email df fd-c ai-c jc-c text-center"
        style={{ padding: 32 }}
      >
        <img
          src={userInfoImg}
          alt="User info required"
          style={{ maxWidth: 100, marginBottom: 32 }}
        />
        <h2 className="fixel_26" style={{ marginBottom: 24 }}>
          {t("wallet.withdraw.noEmailTitle")}
        </h2>
        <p
          className="fixel_16"
          style={{ maxWidth: 400, fontWeight: 400, marginBottom: 24 }}
        >
          {t("wallet.withdraw.noEmailMessage")}
        </p>
        <CustomButton
          def={40}
          classname="pr as-c"
          title={t("wallet.withdraw.goToProfileSettings")}
          onClick={handleGoToProfile}
        />
      </div>
    );
  }

  const changePart = (path = "", queryParams = {}) => {
    setActivePart({ path, queryParams });
  };

  const onConfirm = () => {
    onClose();

    state.setPopUp("data", {
      custom: (e) => (
        <div className="withdraw-confirm df fd-c ai-c text-center gap-32">
          <p className="fixel_26">{t("wallet.withdraw.successful")}</p>
          {!!auth?.email ? (
            <div className="df fd-c ai-c gap-16">
              <p className="fixel_16_sbl">
                {t("wallet.withdraw.confirmRequest")}
              </p>
              <div className="df ai-c gap-6">
                <div className="tico_icon"></div>
                <p className="fixel_26">
                  {payToLocaleString(activePart.queryParams.amountValue)}
                </p>
              </div>
              <p className="fixel_16_sbl">
                {t("wallet.withdraw.checkEmail")}
              </p>
            </div>
          ) : (
            <div className="df fd-c ai-c gap-16">
              <p className="fixel_16_sbl">
                {t("wallet.withdraw.confirmRequestNo2FA")}
              </p>
            </div>
          )}
          <CustomButton
            onClick={() => state.setPopUp("")}
            classname={`grey`}
            def={40}
            title={t("labels.close")}
          />
        </div>
      ),
    });
  };

  return (
    <>
      <Component
        {...{ ...props, changePart, onConfirm, data: activePart.queryParams }}
      />
    </>
  );
}
